import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Jwt } from '../utilities/constants';
import { HttpClientType } from '../enums/http-client-type.enum';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';

const helper = new JwtHelperService();

/** Interceptor that adds jwt token to requests */
@Injectable()
export class JwtHttpInterceptor implements HttpInterceptor {
  constructor(
    private readonly _router: Router,
    private readonly _authService: AuthService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentToken = localStorage.getItem(Jwt.TOKEN_ID);
    const token = currentToken && !helper.isTokenExpired(currentToken) ? currentToken : null;

    if (!token && currentToken) {
      this._authService.logout();
      this._router.navigate(['']);
    }

    const clientType = request.headers.get('clientType');
    const contentType = request.headers.get('Content-Type');
    const isFormData = request.body instanceof FormData;
    let baseUrl = environment.academyApiUrl;
    if (clientType === HttpClientType.Identity.toString()) {
      baseUrl = environment.idsApiUrl;
    }

    const headers: Record<string, string> = {
      Accept: `application/json`,
    };

    if (contentType) {
      headers['Content-Type'] = contentType;
    } else if (!isFormData) {
      headers['Content-Type'] = `application/json`;
    }

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return next
      .handle(
        request.clone({
          setHeaders: headers,
          url: `${baseUrl}${request.url}`,
        })
      )
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this._authService.logout();
            this._router.navigate(['']);
          }
          return throwError(() => error);
        })
      );
  }
}
